var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscussLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6266_116155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 38.0026L18.667 32.1693H10.0003C9.5583 32.1693 9.13437 31.9937 8.82181 31.6811C8.50925 31.3686 8.33366 30.9446 8.33366 30.5026V12.3409C8.33366 11.8989 8.50925 11.475 8.82181 11.1624C9.13437 10.8499 9.5583 10.6743 10.0003 10.6743H36.667C37.109 10.6743 37.5329 10.8499 37.8455 11.1624C38.1581 11.475 38.3337 11.8989 38.3337 12.3409V30.5026C38.3337 30.9446 38.1581 31.3686 37.8455 31.6811C37.5329 31.9937 37.109 32.1693 36.667 32.1693H28.0003L23.3337 38.0026ZM26.3987 28.8359H35.0003V14.0076H11.667V28.8359H20.2687L23.3337 32.6659L26.3987 28.8359ZM3.33366 3.83594H31.667V7.16927H5.00033V25.5026H1.66699V5.5026C1.66699 5.06058 1.84259 4.63665 2.15515 4.32409C2.46771 4.01153 2.89163 3.83594 3.33366 3.83594Z",
    fill: "#22428F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6266_116155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussLine);
export default __webpack_public_path__ + "static/media/discuss-line.bab3f9502924864b479c224589da8ad2.svg";
export { ForwardRef as ReactComponent };